import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Tabs from 'common/Settings/Tabs';
import GoogleSettings from 'common/GoogleSettings';

import styles from './Settings.module.scss';
import MyAccount from './Forms/MyAccount';

export default class Settings extends Component {
  static propTypes = {
    googleConnectionData: PropTypes.shape({
      displayName: PropTypes.string,
      email: PropTypes.string,
      profilePictureUrl: PropTypes.string
    }).isRequired,
    isAutoRostered: PropTypes.bool.isRequired,
    student: PropTypes.shape({
      first_name: PropTypes.string,
      has_strict_password_requirement: PropTypes.bool,
      id: PropTypes.number,
      last_name: PropTypes.string,
      username: PropTypes.string
    }).isRequired,
    studentChangePasswordPath: PropTypes.string.isRequired,
    studentPath: PropTypes.string.isRequired,
  };

  static formatTabs() {
    return (
      [{ key: 'my_account', label: 'My Account' },
        { key: 'integrations', label: 'Integrations' }]
    );
  }

  constructor(props) {
    super(props);

    this.state = {
      activeTab: 'my_account',
      googleConnectionData: props.googleConnectionData
    };

    this.setActiveTab = this.setActiveTab.bind(this);
    this.updateState = this.updateState.bind(this);
  }

  setActiveTab(tab) {
    this.setState({ activeTab: tab });
  }

  _isActive(tab) {
    return this.state.activeTab === tab;
  }

  updateState(newState) {
    this.setState(newState);
  }

  _renderIntegrationsTab() {
    return (
      <GoogleSettings
        active={this._isActive('integrations')}
        connectionData={this.state.googleConnectionData}
        updateState={this.updateState}
        userType="student"
      />
    );
  }

  render() {
    const { activeTab } = this.state;

    return (
      <div className={`dsp-flex ${styles.settings_container}`}>
        <Tabs
          activeTab={activeTab}
          setActiveTab={this.setActiveTab}
          tabs={Settings.formatTabs()}
        />

        <div className={styles.contentContainer}>
          <MyAccount
            active={this._isActive('my_account')}
            isAutoRostered={this.props.isAutoRostered}
            student={this.props.student}
            studentPath={this.props.studentChangePasswordPath}
          />

          {this._renderIntegrationsTab()}
        </div>
      </div>
    );
  }
}
